class Events {
    private events: any;
    constructor() {
        this.events = new Map();
    }

    on(eventName: any, callback: any) {
        const events = this.events.get(eventName) || new Set();
        events.add(callback);
        this.events.set(eventName, events);
    }

    removeEventListener(eventName: any, callback: any) {
        if (this.events.has(eventName)) {
            this.events.get(eventName).delete(callback);
        }
    }

    emit(eventName: any, data: any) {
        if (this.events.has(eventName)) {
            this.events.get(eventName).forEach((callback) => callback(data));
        }
    }
}

export default new Events();
